// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file file.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "./google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "./google/protobuf/timestamp_pb";
import type { EmptyRequest, EmptyResponseSchema } from "./basic_pb";
import { file_basic } from "./basic_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file file.proto.
 */
export const file_file: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_basic]);

/**
 * 文件信息
 *
 * @generated from message puppy.proto.v1.FileInfo
 */
export type FileInfo = Message<"puppy.proto.v1.FileInfo"> & {
  /**
   * 对象 key/目录前缀（文件夹常以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 大小（字节，文件夹为 0）
   *
   * @generated from field: uint64 size = 2;
   */
  size: bigint;

  /**
   * 类型：file / folder / cad_part / cad_assembly / .ext（文件有扩展名时返回 .ext；CAD 包文件按后缀细分）
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * 业务 UUID（普通文件为空；CAD/版本等场景可返回）
   *
   * @generated from field: string uuid = 4;
   */
  uuid: string;

  /**
   * 更新时间
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message puppy.proto.v1.FileInfo.
 * Use `create(FileInfoSchema)` to create a new message.
 */
export const FileInfoSchema: GenMessage<FileInfo> = /*@__PURE__*/
  messageDesc(file_file, 0);

/**
 * 文件上传请求
 *
 * @generated from message puppy.proto.v1.UploadRequest
 */
export type UploadRequest = Message<"puppy.proto.v1.UploadRequest"> & {
  /**
   * @generated from oneof puppy.proto.v1.UploadRequest.payload
   */
  payload: {
    /**
     * 首帧必须是元数据
     *
     * @generated from field: puppy.proto.v1.UploadMetadata metadata = 1;
     */
    value: UploadMetadata;
    case: "metadata";
  } | {
    /**
     * 后续帧为文件块
     *
     * @generated from field: bytes chunk = 2;
     */
    value: Uint8Array;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message puppy.proto.v1.UploadRequest.
 * Use `create(UploadRequestSchema)` to create a new message.
 */
export const UploadRequestSchema: GenMessage<UploadRequest> = /*@__PURE__*/
  messageDesc(file_file, 1);

/**
 * 上传元数据
 *
 * @generated from message puppy.proto.v1.UploadMetadata
 */
export type UploadMetadata = Message<"puppy.proto.v1.UploadMetadata"> & {
  /**
   * 目标对象 key
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 文件大小（用于配额检查）
   *
   * @generated from field: uint64 size = 2;
   */
  size: bigint;
};

/**
 * Describes the message puppy.proto.v1.UploadMetadata.
 * Use `create(UploadMetadataSchema)` to create a new message.
 */
export const UploadMetadataSchema: GenMessage<UploadMetadata> = /*@__PURE__*/
  messageDesc(file_file, 2);

/**
 * 批量导入 CAD 文件请求（双向流：首帧必须是批量 metadata，随后按“单文件 metadata -> chunk* -> file_boundary”重复）
 *
 * @generated from message puppy.proto.v1.BatchImportCadFileRequest
 */
export type BatchImportCadFileRequest = Message<"puppy.proto.v1.BatchImportCadFileRequest"> & {
  /**
   * @generated from oneof puppy.proto.v1.BatchImportCadFileRequest.payload
   */
  payload: {
    /**
     * @generated from field: puppy.proto.v1.BatchImportCadFileMetadata metadata = 1;
     */
    value: BatchImportCadFileMetadata;
    case: "metadata";
  } | {
    /**
     * @generated from field: puppy.proto.v1.ImportFileMetadata file_metadata = 2;
     */
    value: ImportFileMetadata;
    case: "fileMetadata";
  } | {
    /**
     * 当前文件块
     *
     * @generated from field: bytes chunk = 3;
     */
    value: Uint8Array;
    case: "chunk";
  } | {
    /**
     * 当前文件结束边界
     *
     * @generated from field: puppy.proto.v1.EmptyRequest file_boundary = 4;
     */
    value: EmptyRequest;
    case: "fileBoundary";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message puppy.proto.v1.BatchImportCadFileRequest.
 * Use `create(BatchImportCadFileRequestSchema)` to create a new message.
 */
export const BatchImportCadFileRequestSchema: GenMessage<BatchImportCadFileRequest> = /*@__PURE__*/
  messageDesc(file_file, 3);

/**
 * 批量导入 CAD 文件元数据
 *
 * @generated from message puppy.proto.v1.BatchImportCadFileMetadata
 */
export type BatchImportCadFileMetadata = Message<"puppy.proto.v1.BatchImportCadFileMetadata"> & {
  /**
   * 并发数；<=0 或非法时回落到 2，超大值由服务端钳制
   *
   * @generated from field: int32 concurrency = 1;
   */
  concurrency: number;
};

/**
 * Describes the message puppy.proto.v1.BatchImportCadFileMetadata.
 * Use `create(BatchImportCadFileMetadataSchema)` to create a new message.
 */
export const BatchImportCadFileMetadataSchema: GenMessage<BatchImportCadFileMetadata> = /*@__PURE__*/
  messageDesc(file_file, 4);

/**
 * 批量导入 CAD 文件事件
 *
 * @generated from message puppy.proto.v1.BatchImportCadFileEvent
 */
export type BatchImportCadFileEvent = Message<"puppy.proto.v1.BatchImportCadFileEvent"> & {
  /**
   * 当前事件对应文件的目标目录；整批完成事件为空
   *
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * 当前事件对应文件名；整批完成事件为空
   *
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: puppy.proto.v1.BatchImportCadFileEvent.Stage stage = 3;
   */
  stage: BatchImportCadFileEvent_Stage;

  /**
   * 0-100
   *
   * @generated from field: int32 progress_percent = 4;
   */
  progressPercent: number;

  /**
   * 阶段说明
   *
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * 失败原因
   *
   * @generated from field: string error_message = 6;
   */
  errorMessage: string;

  /**
   * 单文件成功时返回
   *
   * @generated from field: puppy.proto.v1.FileInfo file_info = 7;
   */
  fileInfo?: FileInfo | undefined;

  /**
   * 当前批次已成功导入数；每个事件实时返回
   *
   * @generated from field: uint32 success_count = 8;
   */
  successCount: number;

  /**
   * 当前批次已失败导入数；每个事件实时返回
   *
   * @generated from field: uint32 failed_count = 9;
   */
  failedCount: number;

  /**
   * 当前批次已接收文件总数；每个事件实时返回
   *
   * @generated from field: uint32 total_count = 10;
   */
  totalCount: number;

  /**
   * 当前文件是否执行格式转换；step/stp 为 true，其他类型为 false
   *
   * @generated from field: bool is_convert = 11;
   */
  isConvert: boolean;
};

/**
 * Describes the message puppy.proto.v1.BatchImportCadFileEvent.
 * Use `create(BatchImportCadFileEventSchema)` to create a new message.
 */
export const BatchImportCadFileEventSchema: GenMessage<BatchImportCadFileEvent> = /*@__PURE__*/
  messageDesc(file_file, 5);

/**
 * @generated from enum puppy.proto.v1.BatchImportCadFileEvent.Stage
 */
export enum BatchImportCadFileEvent_Stage {
  /**
   * @generated from enum value: STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 接收/处理单文件中
   *
   * @generated from enum value: STAGE_UPLOADING = 1;
   */
  UPLOADING = 1,

  /**
   * 转换中
   *
   * @generated from enum value: STAGE_CONVERTING = 2;
   */
  CONVERTING = 2,

  /**
   * 保存中
   *
   * @generated from enum value: STAGE_SAVING = 3;
   */
  SAVING = 3,

  /**
   * 单文件导入成功
   *
   * @generated from enum value: STAGE_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * 单文件导入失败
   *
   * @generated from enum value: STAGE_FAILED = 5;
   */
  FAILED = 5,

  /**
   * 整批处理完成
   *
   * @generated from enum value: STAGE_BATCH_COMPLETED = 6;
   */
  BATCH_COMPLETED = 6,
}

/**
 * Describes the enum puppy.proto.v1.BatchImportCadFileEvent.Stage.
 */
export const BatchImportCadFileEvent_StageSchema: GenEnum<BatchImportCadFileEvent_Stage> = /*@__PURE__*/
  enumDesc(file_file, 5, 0);

/**
 * 文件夹创建请求
 *
 * @generated from message puppy.proto.v1.CreateFolderRequest
 */
export type CreateFolderRequest = Message<"puppy.proto.v1.CreateFolderRequest"> & {
  /**
   * 目录前缀（可不以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message puppy.proto.v1.CreateFolderRequest.
 * Use `create(CreateFolderRequestSchema)` to create a new message.
 */
export const CreateFolderRequestSchema: GenMessage<CreateFolderRequest> = /*@__PURE__*/
  messageDesc(file_file, 6);

/**
 * 文件重命名请求
 *
 * @generated from message puppy.proto.v1.RenameRequest
 */
export type RenameRequest = Message<"puppy.proto.v1.RenameRequest"> & {
  /**
   * 目标文件/文件夹 ID（文件夹必须以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 新名称（不含路径）
   *
   * @generated from field: string new_name = 2;
   */
  newName: string;

  /**
   * 业务 UUID（仅在需要精确校验时填写）
   *
   * @generated from field: string file_uuid = 3;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.RenameRequest.
 * Use `create(RenameRequestSchema)` to create a new message.
 */
export const RenameRequestSchema: GenMessage<RenameRequest> = /*@__PURE__*/
  messageDesc(file_file, 7);

/**
 * 文件移动请求
 *
 * @generated from message puppy.proto.v1.MoveRequest
 */
export type MoveRequest = Message<"puppy.proto.v1.MoveRequest"> & {
  /**
   * 源文件/文件夹 ID（文件夹必须以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 目标父目录前缀（根目录为空）
   *
   * @generated from field: string new_parent_id = 2;
   */
  newParentId: string;

  /**
   * 业务 UUID（仅在需要精确校验时填写）
   *
   * @generated from field: string file_uuid = 3;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.MoveRequest.
 * Use `create(MoveRequestSchema)` to create a new message.
 */
export const MoveRequestSchema: GenMessage<MoveRequest> = /*@__PURE__*/
  messageDesc(file_file, 8);

/**
 * 文件复制请求
 *
 * @generated from message puppy.proto.v1.CopyRequest
 */
export type CopyRequest = Message<"puppy.proto.v1.CopyRequest"> & {
  /**
   * 源文件/文件夹 ID（文件夹必须以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 目标父目录前缀（根目录为空）
   *
   * @generated from field: string target_parent_id = 2;
   */
  targetParentId: string;

  /**
   * 业务 UUID（仅在需要精确校验时填写）
   *
   * @generated from field: string file_uuid = 3;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.CopyRequest.
 * Use `create(CopyRequestSchema)` to create a new message.
 */
export const CopyRequestSchema: GenMessage<CopyRequest> = /*@__PURE__*/
  messageDesc(file_file, 9);

/**
 * 文件列表请求
 *
 * @generated from message puppy.proto.v1.ListFilesRequest
 */
export type ListFilesRequest = Message<"puppy.proto.v1.ListFilesRequest"> & {
  /**
   * 目录前缀（根目录为空）
   *
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * 类型过滤：file / folder / cad_part / cad_assembly / all / .ext（空=all）
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大 1000）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * 排序字段（空/UNSPECIFIED=服务端默认：名称 ASC）
   *
   * @generated from field: puppy.proto.v1.FileSortBy sort_by = 5;
   */
  sortBy: FileSortBy;

  /**
   * 排序方向（空/UNSPECIFIED=服务端默认方向）
   *
   * @generated from field: puppy.proto.v1.SortOrder sort_order = 6;
   */
  sortOrder: SortOrder;
};

/**
 * Describes the message puppy.proto.v1.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema: GenMessage<ListFilesRequest> = /*@__PURE__*/
  messageDesc(file_file, 10);

/**
 * 文件列表响应
 *
 * @generated from message puppy.proto.v1.ListFilesResponse
 */
export type ListFilesResponse = Message<"puppy.proto.v1.ListFilesResponse"> & {
  /**
   * 列表
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.ListFilesResponse.
 * Use `create(ListFilesResponseSchema)` to create a new message.
 */
export const ListFilesResponseSchema: GenMessage<ListFilesResponse> = /*@__PURE__*/
  messageDesc(file_file, 11);

/**
 * 文件树请求
 *
 * @generated from message puppy.proto.v1.FileTreeRequest
 */
export type FileTreeRequest = Message<"puppy.proto.v1.FileTreeRequest"> & {
  /**
   * 目录前缀（根目录为空）
   *
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * 类型过滤：file / folder / cad_part / cad_assembly / all / .ext（空=all）
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大 1000）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message puppy.proto.v1.FileTreeRequest.
 * Use `create(FileTreeRequestSchema)` to create a new message.
 */
export const FileTreeRequestSchema: GenMessage<FileTreeRequest> = /*@__PURE__*/
  messageDesc(file_file, 12);

/**
 * 文件树响应
 *
 * @generated from message puppy.proto.v1.FileTreeResponse
 */
export type FileTreeResponse = Message<"puppy.proto.v1.FileTreeResponse"> & {
  /**
   * 树节点列表
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.FileTreeResponse.
 * Use `create(FileTreeResponseSchema)` to create a new message.
 */
export const FileTreeResponseSchema: GenMessage<FileTreeResponse> = /*@__PURE__*/
  messageDesc(file_file, 13);

/**
 * 搜索文件请求
 *
 * @generated from message puppy.proto.v1.SearchFilesRequest
 */
export type SearchFilesRequest = Message<"puppy.proto.v1.SearchFilesRequest"> & {
  /**
   * 关键词（可空）
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * 目录前缀（根目录为空）
   *
   * @generated from field: string folder_id = 2;
   */
  folderId: string;

  /**
   * 类型过滤（兼容旧参数）：file / folder / cad_part / cad_assembly / all / .ext（空=all；当 kinds 非空时忽略）
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大 1000）
   *
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * 排序字段（空/UNSPECIFIED=服务端默认：名称 ASC）
   *
   * @generated from field: puppy.proto.v1.FileSortBy sort_by = 6;
   */
  sortBy: FileSortBy;

  /**
   * 排序方向（空/UNSPECIFIED=服务端默认方向）
   *
   * @generated from field: puppy.proto.v1.SortOrder sort_order = 7;
   */
  sortOrder: SortOrder;

  /**
   * 类型过滤数组：支持同时传多个类型做 OR 匹配（如 cad_part + cad_assembly）
   *
   * @generated from field: repeated string kinds = 8;
   */
  kinds: string[];
};

/**
 * Describes the message puppy.proto.v1.SearchFilesRequest.
 * Use `create(SearchFilesRequestSchema)` to create a new message.
 */
export const SearchFilesRequestSchema: GenMessage<SearchFilesRequest> = /*@__PURE__*/
  messageDesc(file_file, 14);

/**
 * 搜索文件响应
 *
 * @generated from message puppy.proto.v1.SearchFilesResponse
 */
export type SearchFilesResponse = Message<"puppy.proto.v1.SearchFilesResponse"> & {
  /**
   * 命中列表
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.SearchFilesResponse.
 * Use `create(SearchFilesResponseSchema)` to create a new message.
 */
export const SearchFilesResponseSchema: GenMessage<SearchFilesResponse> = /*@__PURE__*/
  messageDesc(file_file, 15);

/**
 * 最近文件请求
 *
 * @generated from message puppy.proto.v1.ListRecentFilesRequest
 */
export type ListRecentFilesRequest = Message<"puppy.proto.v1.ListRecentFilesRequest"> & {
  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大 1000）
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * 类型过滤：file / folder / cad_part / cad_assembly / all / .ext（空=all）
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * 关键词（可空）：按名称做 contains 匹配（忽略大小写）
   *
   * @generated from field: string query = 4;
   */
  query: string;

  /**
   * 排序字段（空/UNSPECIFIED=服务端默认：修改时间 DESC）
   *
   * @generated from field: puppy.proto.v1.FileSortBy sort_by = 5;
   */
  sortBy: FileSortBy;

  /**
   * 排序方向（空/UNSPECIFIED=服务端默认方向）
   *
   * @generated from field: puppy.proto.v1.SortOrder sort_order = 6;
   */
  sortOrder: SortOrder;
};

/**
 * Describes the message puppy.proto.v1.ListRecentFilesRequest.
 * Use `create(ListRecentFilesRequestSchema)` to create a new message.
 */
export const ListRecentFilesRequestSchema: GenMessage<ListRecentFilesRequest> = /*@__PURE__*/
  messageDesc(file_file, 16);

/**
 * 最近文件响应
 *
 * @generated from message puppy.proto.v1.ListRecentFilesResponse
 */
export type ListRecentFilesResponse = Message<"puppy.proto.v1.ListRecentFilesResponse"> & {
  /**
   * 最近列表
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.ListRecentFilesResponse.
 * Use `create(ListRecentFilesResponseSchema)` to create a new message.
 */
export const ListRecentFilesResponseSchema: GenMessage<ListRecentFilesResponse> = /*@__PURE__*/
  messageDesc(file_file, 17);

/**
 * 下载请求
 *
 * @generated from message puppy.proto.v1.DownloadRequest
 */
export type DownloadRequest = Message<"puppy.proto.v1.DownloadRequest"> & {
  /**
   * 目标文件/文件夹 ID（文件夹必须以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 业务 UUID（仅在需要精确校验时使用）
   *
   * @generated from field: string file_uuid = 2;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest> = /*@__PURE__*/
  messageDesc(file_file, 18);

/**
 * 下载 ID 响应
 *
 * @generated from message puppy.proto.v1.DownloadIDResponse
 */
export type DownloadIDResponse = Message<"puppy.proto.v1.DownloadIDResponse"> & {
  /**
   * 下载会话 ID
   *
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * Describes the message puppy.proto.v1.DownloadIDResponse.
 * Use `create(DownloadIDResponseSchema)` to create a new message.
 */
export const DownloadIDResponseSchema: GenMessage<DownloadIDResponse> = /*@__PURE__*/
  messageDesc(file_file, 19);

/**
 * 删除请求
 *
 * @generated from message puppy.proto.v1.DeleteRequest
 */
export type DeleteRequest = Message<"puppy.proto.v1.DeleteRequest"> & {
  /**
   * 目标文件/文件夹 ID（文件夹必须以 / 结尾）
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;

  /**
   * 业务 UUID（仅在需要精确校验时使用）
   *
   * @generated from field: string file_uuid = 2;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest> = /*@__PURE__*/
  messageDesc(file_file, 20);

/**
 * 导入 CAD 文件请求（双向流：首帧必须是 metadata，后续为 chunk）
 *
 * @generated from message puppy.proto.v1.ImportFileRequest
 */
export type ImportFileRequest = Message<"puppy.proto.v1.ImportFileRequest"> & {
  /**
   * @generated from oneof puppy.proto.v1.ImportFileRequest.payload
   */
  payload: {
    /**
     * @generated from field: puppy.proto.v1.ImportFileMetadata metadata = 1;
     */
    value: ImportFileMetadata;
    case: "metadata";
  } | {
    /**
     * 文件块
     *
     * @generated from field: bytes chunk = 2;
     */
    value: Uint8Array;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message puppy.proto.v1.ImportFileRequest.
 * Use `create(ImportFileRequestSchema)` to create a new message.
 */
export const ImportFileRequestSchema: GenMessage<ImportFileRequest> = /*@__PURE__*/
  messageDesc(file_file, 21);

/**
 * 导入 CAD 文件元数据（转换后保存为按工程类型区分的单文件 CAD 包，支持零件/装配体导入模式）
 *
 * @generated from message puppy.proto.v1.ImportFileMetadata
 */
export type ImportFileMetadata = Message<"puppy.proto.v1.ImportFileMetadata"> & {
  /**
   * CAD 包要创建到的目标目录（根目录为空）
   *
   * @generated from field: string folder_id = 1;
   */
  folderId: string;

  /**
   * CAD 源文件名（必须指定，扩展名用于推断输入格式与 CAD 包文件名）
   *
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * step/stp类型需指定导入模式：零件或装配体，其余类型不需要
   *
   * @generated from field: puppy.proto.v1.ImportCadMode import_mode = 3;
   */
  importMode: ImportCadMode;

  /**
   * 源文件大小（字节，用于更新上传进度与配额相关检查）
   *
   * @generated from field: uint64 file_size = 4;
   */
  fileSize: bigint;
};

/**
 * Describes the message puppy.proto.v1.ImportFileMetadata.
 * Use `create(ImportFileMetadataSchema)` to create a new message.
 */
export const ImportFileMetadataSchema: GenMessage<ImportFileMetadata> = /*@__PURE__*/
  messageDesc(file_file, 22);

/**
 * 导入文件进度事件
 *
 * @generated from message puppy.proto.v1.ImportFileEvent
 */
export type ImportFileEvent = Message<"puppy.proto.v1.ImportFileEvent"> & {
  /**
   * @generated from field: puppy.proto.v1.ImportFileEvent.Stage stage = 1;
   */
  stage: ImportFileEvent_Stage;

  /**
   * 0-100
   *
   * @generated from field: int32 progress_percent = 2;
   */
  progressPercent: number;

  /**
   * 状态描述/错误信息
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * 完成时返回最终文件信息（如果是转换，返回转换后的文件）
   *
   * @generated from field: puppy.proto.v1.FileInfo file_info = 4;
   */
  fileInfo?: FileInfo | undefined;

  /**
   * 如果发生了转换，这里可返回原始导入的文件信息
   *
   * @generated from field: puppy.proto.v1.FileInfo original_file_info = 5;
   */
  originalFileInfo?: FileInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.ImportFileEvent.
 * Use `create(ImportFileEventSchema)` to create a new message.
 */
export const ImportFileEventSchema: GenMessage<ImportFileEvent> = /*@__PURE__*/
  messageDesc(file_file, 23);

/**
 * @generated from enum puppy.proto.v1.ImportFileEvent.Stage
 */
export enum ImportFileEvent_Stage {
  /**
   * @generated from enum value: STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 上传中
   *
   * @generated from enum value: STAGE_UPLOADING = 1;
   */
  UPLOADING = 1,

  /**
   * 转换中（仅当请求了转换）
   *
   * @generated from enum value: STAGE_CONVERTING = 2;
   */
  CONVERTING = 2,

  /**
   * 保存中
   *
   * @generated from enum value: STAGE_SAVING = 3;
   */
  SAVING = 3,

  /**
   * 完成
   *
   * @generated from enum value: STAGE_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * 失败
   *
   * @generated from enum value: STAGE_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum puppy.proto.v1.ImportFileEvent.Stage.
 */
export const ImportFileEvent_StageSchema: GenEnum<ImportFileEvent_Stage> = /*@__PURE__*/
  enumDesc(file_file, 23, 0);

/**
 * 文件排序字段
 * 说明：FILE_SORT_BY_NAME 按 FileInfo.file_id（相对用户根目录的路径字符串）排序。
 *
 * @generated from enum puppy.proto.v1.FileSortBy
 */
export enum FileSortBy {
  /**
   * 未指定（由服务端使用默认排序）
   *
   * @generated from enum value: FILE_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 名称（file_id 字符串）
   *
   * @generated from enum value: FILE_SORT_BY_NAME = 1;
   */
  NAME = 1,

  /**
   * 大小
   *
   * @generated from enum value: FILE_SORT_BY_SIZE = 2;
   */
  SIZE = 2,

  /**
   * 类型
   *
   * @generated from enum value: FILE_SORT_BY_KIND = 3;
   */
  KIND = 3,

  /**
   * 修改时间（updated_at）
   *
   * @generated from enum value: FILE_SORT_BY_UPDATED_AT = 4;
   */
  UPDATED_AT = 4,
}

/**
 * Describes the enum puppy.proto.v1.FileSortBy.
 */
export const FileSortBySchema: GenEnum<FileSortBy> = /*@__PURE__*/
  enumDesc(file_file, 0);

/**
 * 排序方向
 *
 * @generated from enum puppy.proto.v1.SortOrder
 */
export enum SortOrder {
  /**
   * 未指定（由服务端使用默认方向）
   *
   * @generated from enum value: SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 升序
   *
   * @generated from enum value: SORT_ORDER_ASC = 1;
   */
  ASC = 1,

  /**
   * 降序
   *
   * @generated from enum value: SORT_ORDER_DESC = 2;
   */
  DESC = 2,
}

/**
 * Describes the enum puppy.proto.v1.SortOrder.
 */
export const SortOrderSchema: GenEnum<SortOrder> = /*@__PURE__*/
  enumDesc(file_file, 1);

/**
 * 导入 CAD 文件模式
 *
 * @generated from enum puppy.proto.v1.ImportCadMode
 */
export enum ImportCadMode {
  /**
   * 默认：按装配体单文件导入
   *
   * @generated from enum value: IMPORT_CAD_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 导入为单个零件 glb
   *
   * @generated from enum value: IMPORT_CAD_MODE_PART = 1;
   */
  PART = 1,

  /**
   * 导入为装配体 glb
   *
   * @generated from enum value: IMPORT_CAD_MODE_ASSEMBLY = 2;
   */
  ASSEMBLY = 2,
}

/**
 * Describes the enum puppy.proto.v1.ImportCadMode.
 */
export const ImportCadModeSchema: GenEnum<ImportCadMode> = /*@__PURE__*/
  enumDesc(file_file, 2);

/**
 * 文件服务
 *
 * @generated from service puppy.proto.v1.FileService
 */
export const FileService: GenService<{
  /**
   * 初始化上传（直接流式上传）
   *
   * @generated from rpc puppy.proto.v1.FileService.Upload
   */
  upload: {
    methodKind: "client_streaming";
    input: typeof UploadRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * 获取下载 ID
   *
   * @generated from rpc puppy.proto.v1.FileService.GetDownloadID
   */
  getDownloadID: {
    methodKind: "unary";
    input: typeof DownloadRequestSchema;
    output: typeof DownloadIDResponseSchema;
  },
  /**
   * 创建文件夹
   *
   * @generated from rpc puppy.proto.v1.FileService.CreateFolder
   */
  createFolder: {
    methodKind: "unary";
    input: typeof CreateFolderRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * 重命名
   *
   * @generated from rpc puppy.proto.v1.FileService.Rename
   */
  rename: {
    methodKind: "unary";
    input: typeof RenameRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * 移动
   *
   * @generated from rpc puppy.proto.v1.FileService.Move
   */
  move: {
    methodKind: "unary";
    input: typeof MoveRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * 复制
   *
   * @generated from rpc puppy.proto.v1.FileService.Copy
   */
  copy: {
    methodKind: "unary";
    input: typeof CopyRequestSchema;
    output: typeof FileInfoSchema;
  },
  /**
   * 删除
   *
   * @generated from rpc puppy.proto.v1.FileService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 获取列表
   *
   * @generated from rpc puppy.proto.v1.FileService.ListFiles
   */
  listFiles: {
    methodKind: "unary";
    input: typeof ListFilesRequestSchema;
    output: typeof ListFilesResponseSchema;
  },
  /**
   * 获取树
   *
   * @generated from rpc puppy.proto.v1.FileService.GetFileTree
   */
  getFileTree: {
    methodKind: "unary";
    input: typeof FileTreeRequestSchema;
    output: typeof FileTreeResponseSchema;
  },
  /**
   * 搜索
   *
   * @generated from rpc puppy.proto.v1.FileService.SearchFiles
   */
  searchFiles: {
    methodKind: "unary";
    input: typeof SearchFilesRequestSchema;
    output: typeof SearchFilesResponseSchema;
  },
  /**
   * 获取最近
   *
   * @generated from rpc puppy.proto.v1.FileService.ListRecentFiles
   */
  listRecentFiles: {
    methodKind: "unary";
    input: typeof ListRecentFilesRequestSchema;
    output: typeof ListRecentFilesResponseSchema;
  },
  /**
   * 导入 CAD 文件（转换后生成并保存单文件 CAD 包，支持零件/装配体导入模式）
   *
   * @generated from rpc puppy.proto.v1.FileService.ImportCadFile
   */
  importCadFile: {
    methodKind: "bidi_streaming";
    input: typeof ImportFileRequestSchema;
    output: typeof ImportFileEventSchema;
  },
  /**
   * 批量导入 CAD 文件（首帧必须是批量元数据；单文件失败时继续处理后续文件，并在最终事件中汇总结果）
   *
   * @generated from rpc puppy.proto.v1.FileService.BatchImportCadFile
   */
  batchImportCadFile: {
    methodKind: "bidi_streaming";
    input: typeof BatchImportCadFileRequestSchema;
    output: typeof BatchImportCadFileEventSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_file, 0);

